export const HEADER_SET_NB_CONSULTANT_PHONE = 'header:set_newbuilding_consultant_phone';
